// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"80c935fb","52":"8fd27523","135":"e6d3de11","204":"238dd094","289":"13b10873","421":"aff46a1e","459":"43d12629","487":"0edd8589","530":"0562fddc","537":"f0372046","613":"b36fb2e5","649":"85f99fac","670":"26c94c8f","830":"a2257bbb"}[chunkId] + ".chunk.js";
};